import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { NOTIFICATIONS_MOCK } from '../../mocks/notifications.mock';
import { INotificationItem, INotificationItemMenu, INotificationsGenerals } from '../model/notification/notification-item.model';
import { IBodyCreateTemplateNotification, IGetParams, IResNotificationTransactionalChannel } from '../model/notification/notification-template.model';
import { INotificationTransactional, IResCatalogChanel, IResCatalogServices, IResFindNotificationTransactional, IResNotificationTransactional } from '../model/notification/notification-transactional.model';
import { IDataCountNotification, IDataNotification } from '../model/notification/notifications.model';
import { IConventionalRes, ITipification, ITipificationConsult } from '../model/notification/tipification-settings.model';
import { IBodyForTestWhatsappTemplate, IBodyRequestWhatsappTemplate, IResFindWhatsappTemplate, IResWhatsappTemplate, IWhatsappTemplate } from '../model/notification/whatsapp-template.model';
import { IAcceptanceLetter, IBodyForCreateAcceptanceLetter, IResAcceptanceLetter, IResFindAcceptanceLetter } from '../model/templates/acceptance-letters.model';
import { ConsumeService } from './consume.service';
import { ITipificationServiceDto, ITipificationServiceResponse } from '../model/notification/tipification-services.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  notifications: INotificationItem[] = NOTIFICATIONS_MOCK.slice(0, 10);

  constructor(
    private readonly consumeService: ConsumeService,
    private readonly http: HttpClient
  ) { }

  getAllNotifications(userId: string, size: number, page: number): Observable<INotificationItemMenu[]> {
    return this.consumeService.httpGet<IDataNotification>(
      `${Endpoints.notifications.base}?userId=${userId}&size=${size}&page=${page}`
    ).pipe(map(resp => resp.list));
  }
  getOnlyNotReadNotifications(userId: string, size: number, page: number): Observable<INotificationItemMenu[]> {
    return this.consumeService.httpGet<IDataNotification>(
      `${Endpoints.notifications.base}/not-read?userId=${userId}&size=${size}&page=${page}`
    ).pipe(map(resp => resp.list));
  }

  getCountNotifications(userId: string): Observable<number> {
    return this.consumeService.httpGet<IDataCountNotification>(
      `${Endpoints.notifications.base}/count?userId=${userId}`
    ).pipe(map(resp => resp.data));
  }


  updateReadOnlyNotification(id: number) {
    return this.http.patch(`${Endpoints.notifications.base}/update?id=${id}`, {});
  }

  updateReadAllNotifications(userId: string) {
    return this.http.patch(`${Endpoints.notifications.base}/update-all?userId=${userId}`, {});
  }

  getGeneralsNotifications(userId: string, size: number, page: number): Observable<INotificationsGenerals[]> {
    return this.consumeService.httpGet<IDataNotification>(
      `${Endpoints.notifications.base}/generals?userId=${userId}&size=${size}&page=${page}`
    ).pipe(map(resp => resp.list));
  }

  getTransactionalNotifications(params: string): Observable<IResNotificationTransactional> {
    return this.consumeService.httpGet<IResNotificationTransactional>(
      `${Endpoints.notifications.transactional}/all?${params}`
    );
  }

  findTransactionalNotification(word: string): Observable<INotificationTransactional[]> {
    return this.consumeService.httpGet<IResFindNotificationTransactional>(
      `${Endpoints.notifications.transactional}/names?name=${word}`
    ).pipe(map((res) => res.data));
  }

  exportTransactionalNotifications() {
    return this.http.get(`${Endpoints.notifications.transactional}/export`, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(map((res) => res.body));
  }

  updateStatusTransactionalNotification(id: number, status: boolean) {
    return this.http.patch(`${Endpoints.notifications.transactional}?id=${id}&status=${status}`, {});
  }

  deleteTransactionalNotification(id: number) {
    return this.consumeService.httpDelete(`${Endpoints.notifications.transactional}?id=${id}`);
  }


  getCatalogServices(grouper: string, discard: boolean, discardLetter: boolean = false) {
    return this.consumeService.httpGet<IResCatalogServices>(`${Endpoints.notifications.transactional}/services?grouper=${grouper}&discard=${discard}&discardLetter=${discardLetter}`);
  }

  getCatalogChanel() {
    return this.consumeService.httpGet<IResCatalogChanel>(`${Endpoints.notifications.templates}/channels-dropdown`);
  }
  getCatalogTemplateHubspod(generic: boolean) {
    return this.consumeService.httpGet<any>(`${Endpoints.notifications.templates}/dropdown-hubspot?generic=${generic}`);
  }

  getCatalogTemplate(chanelId: number) {
    return this.consumeService.httpGet(`${Endpoints.notifications.transactional}/templates?channelId=${chanelId}`);
  }




  updateStatusTemplatesNotification(id: number, status: boolean, user: string) {
    return this.http.patch(`${Endpoints.notifications.templates}?templateId=${id}&status=${status}&userUpdate=${user}`, {});
  }

  createTemplateNotification(data: IBodyCreateTemplateNotification) {
    return this.consumeService.httpPost(`${Endpoints.notifications.templates}`, data);
  }

  editTemplateNotification(data: IBodyCreateTemplateNotification) {
    return this.consumeService.httpPut(`${Endpoints.notifications.templates}`, data);
  }
  getNotificationsByIds(serviceID: number, chanelId: number) {
    return this.consumeService.httpGet<IResNotificationTransactionalChannel>(`${Endpoints.notifications.templates}?serviceId=${serviceID}&channelId=${chanelId}`);
  }

  getNotificationsChannelByIds(templateId: number,) {
    return this.consumeService.httpGet<IResNotificationTransactionalChannel>(`${Endpoints.notifications.templates}/detail?templateId=${templateId}`);
  }

  getCatalogParams() {
    return this.consumeService.httpGet<IGetParams>(`${Endpoints.notifications.templates}/parameters-dropdown`);
  }

  // =================================================================
  // ACCEPTANCE LETTER
  // =================================================================
  getAccepatanceLetters(params: string): Observable<IResAcceptanceLetter> {
    return this.consumeService.httpGet<IResAcceptanceLetter>(
      `${Endpoints.notifications.letters}/all?${params}`
    );
  }
  findAccepatanceLetter(word: string): Observable<IAcceptanceLetter[]> {
    return this.consumeService.httpGet<IResFindAcceptanceLetter>(
      `${Endpoints.notifications.letters}/names?name=${word}`
    ).pipe(map((res) => res.data));
  }
  exportAccepatanceLetters() {
    return this.http.get(`${Endpoints.notifications.letters}/export`, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(map((res) => res.body));
  }
  updateStatusAccepatanceLette(id: number, status: boolean) {
    return this.http.patch(`${Endpoints.notifications.letters}?id=${id}&status=${status}`, {});
  }
  deleteAccepatanceLetter(id: number) {
    return this.consumeService.httpDelete(`${Endpoints.notifications.letters}?id=${id}`);
  }
  detailAcceptanceLetter(id: string) {
    return this.consumeService.httpGet<IBodyForCreateAcceptanceLetter>(`${Endpoints.notifications.letters}/details?id=${id}`);
  }
  createAccepatanceLetter(data: IBodyForCreateAcceptanceLetter) {
    return this.consumeService.httpPost(`${Endpoints.notifications.letters}`, data);
  }
  editAccepatanceLetter(data: IBodyForCreateAcceptanceLetter) {
    return this.consumeService.httpPut(`${Endpoints.notifications.letters}`, data);
  }

  /// =================================================================
  /// WHATSAPP TEMPLATES
  /// =================================================================
  getWhatsappTemplates(params: string): Observable<IResWhatsappTemplate> {
    return this.consumeService.httpGet<IResWhatsappTemplate>(
      `${Endpoints.notifications.whatsapp}/all?${params}`
    );
  }
  findWhatsappTemplate(word: string): Observable<IWhatsappTemplate[]> {
    return this.consumeService.httpGet<IResFindWhatsappTemplate>(
      `${Endpoints.notifications.whatsapp}/name?name=${word}`
    ).pipe(map((res) => res.data));
  }
  exportWhatsappTemplates() {
    return this.http.get(`${Endpoints.notifications.whatsapp}/export`, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(map((res) => res.body));
  }
  updateStatusWhatsappTemplate(id: number, status: boolean) {
    return this.http.patch(`${Endpoints.notifications.whatsapp}?whatsappTemplateId=${id}&status=${status}`, {});
  }
  deleteWhatsappTemplate(id: number) {
    return this.consumeService.httpDelete(`${Endpoints.notifications.whatsapp}?whatsappTemplateId=${id}`);
  }
  createWhatsappTemplete(data: IBodyRequestWhatsappTemplate) {
    return this.consumeService.httpPost(`${Endpoints.notifications.whatsapp}`, data);
  }
  editWhatsappTemplete(data: IBodyRequestWhatsappTemplate) {
    return this.consumeService.httpPut(`${Endpoints.notifications.whatsapp}`, data);
  }

  testWhatsappTemplete(data: IBodyForTestWhatsappTemplate) {
    return this.consumeService.httpPost(`${Endpoints.notifications.whatsapp}/test`, data);
  }
  /// =================================================================
  /// TIPIFICATION
  /// =================================================================
  getTipifications(params: string): Observable<ITipificationConsult> {
    return this.consumeService.httpGet<ITipificationConsult>(
      `${Endpoints.tipification.settings}/all?${params}`
    ).pipe(map((res) => res));
  }

  getTipificationsById(id: string): Observable<ITipification> {
    return this.consumeService.httpGet<IConventionalRes>(
      `${Endpoints.tipification.settings}/details?id=${id}`
    ).pipe(map((res) => res.data));
  }
  getTipificationsAutoComplete(name: string): Observable<any[]> {
    return this.consumeService.httpGet<any>(
      `${Endpoints.tipification.settings}/names?name=${name}`
    ).pipe(map((res) => res.data));
  }

  exportTipifications() {
    return this.http.get(`${Endpoints.tipification.settings}/download`, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(map((res) => res.body));
  }

  editTipification(data: ITipification) {
    return this.consumeService.httpPut(`${Endpoints.tipification.settings}`, data);
  }

  createTipification(data: ITipification) {
    return this.consumeService.httpPost(`${Endpoints.tipification.settings}`, data);
  }

  getCatalogServicesTipifications() : Observable<ITipificationServiceDto[]> {
    return this.consumeService.httpGet<ITipificationServiceResponse>(`${Endpoints.tipification.settings}/dropdown`).pipe(
      map((resp) => resp.data)
    );
  }


}
